import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from './ui/sheet';

/**
 * Shared settings-drawer chrome — right-side Sheet, dark bg, purple accents.
 * Keeps the Song/Format drawer look consistent across every Settings row drawer.
 */
export function SettingsDrawer({ open, onOpenChange, title, description, children, testId }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="bg-zinc-950 border-l border-white/10 text-white w-full sm:max-w-md overflow-y-auto"
        data-testid={testId}
      >
        <SheetHeader className="text-left">
          <SheetTitle className="text-white text-xl">{title}</SheetTitle>
          {description ? (
            <SheetDescription className="text-zinc-400 text-sm">
              {description}
            </SheetDescription>
          ) : null}
        </SheetHeader>
        <div className="mt-6">{children}</div>
      </SheetContent>
    </Sheet>
  );
}
